// Ensure API URL is properly formatted
const API_URL = process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.endsWith('/')
        ? process.env.REACT_APP_API_URL.slice(0, -1)
        : process.env.REACT_APP_API_URL
    : 'https://api.aboutcars.pk';

// API endpoint for API calls (includes /api path)
export const API_ENDPOINT = process.env.REACT_APP_API_URL || 'https://api.aboutcars.pk/api';

// Base URL for static files (without /api path)
// Extract base URL by removing '/api' from the end if present
export const BASE_URL = API_ENDPOINT.endsWith('/api')
    ? API_ENDPOINT.slice(0, -4)  // Remove '/api' from the end
    : API_ENDPOINT.replace(/\/api$/, ''); // Remove '/api' if it's at the end

// Helper function to validate and format API URLs
export const getValidApiUrl = (endpoint) => {
    try {
        if (!endpoint) {
            throw new Error('Endpoint is required');
        }

        // Remove leading slash if present
        const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

        // Construct the full URL
        const fullUrl = `${API_ENDPOINT}/${cleanEndpoint}`;

        // Validate the URL
        new URL(fullUrl);

        return fullUrl;
    } catch (error) {
        console.error('Invalid API URL:', error);
        return null;
    }
}; 